import Dialog from '@anm/components/modals/Dialog';
import AlertBlock from '@anm/components/notification/AlertBlock';
import { useEffect, useState, FC } from 'react';

import { ErrorAlertProps, ErrorControl } from './types';

const useErrorControl = (isPending: boolean, error?: ErrorAlertProps['error']) => {
  const isError = !!error;
  const [errorControl, setErrorControl] = useState<ErrorControl>({
    isError: false,
    isShown: false,
    isActive: false
  });

  useEffect(() => {
    if (!isPending) return;
    setErrorControl(prevState => ({ ...prevState, isActive: true }));
  }, [isPending]);

  useEffect(() => {
    if (isError === errorControl.isError || !errorControl.isActive) return;
    setErrorControl(prevState => ({ ...prevState, isError, isShown: false }));
  });

  const setShown = () => {
    setErrorControl(prevState => ({ ...prevState, isShown: true }));
  };
  return { errorControl, setShown };
};

const ErrorAlert: FC<ErrorAlertProps> = ({ isPending, error, onClose = () => {} }) => {
  const { errorControl, setShown } = useErrorControl(isPending, error);

  const handleClose = () => {
    setShown();
    onClose();
  };

  if (!errorControl.isError || errorControl.isShown) return null;

  return (
    <Dialog onModalClose={handleClose} onSubmit={handleClose}>
      <AlertBlock onButtonClick={handleClose} title={error?.message?.title} description={error?.message?.description} />
    </Dialog>
  );
};
export default ErrorAlert;
